import React from "react";
import Carousel from "../../Sections/Carousel";
import Download from "../../Sections/Download";
import { Hero } from "../../Sections/Hero";
import SliderHero from "../../Sections/SliderHero";
import Hejozati from "../../Sections/Hejozati";
import LatestNews from "../../Sections/LatestNews";
import PlatformNews from "../../Sections/PlatformNews";
import Whatsapp from "../../Components/Whatsapp/Whatsapp";
import Sponsored from "../../Sections/Sponsored";

function Home() {
  return (
    <>
      <Carousel />
      <Download />
      <Hero />
      <SliderHero />

      <Hejozati />
      <LatestNews />
      <PlatformNews />
      <Sponsored />
      <Whatsapp />
    </>
  );
}

export default Home;
